var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen"},[(!_vm.iframeVisible)?_c('div',{staticClass:"screen screen-loading"},[_c('SignatureLoadingScreenVue',{attrs:{"hideBackButton":true}})],1):_vm._e(),_c('div',{class:{
    'docusign-area': true,
    'docusign-area__visible': _vm.iframeVisible,
  },attrs:{"id":"docusign"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }